import BaseError from "./BaseError";

export default class CachedResponseNotFound extends BaseError {
  constructor(url: string) {
    super('Cached Response Not Found', `Response to "${url}" does not exist in cache.`);
  }
}